import { Link } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui";

export function NotFound({ children }: { children?: React.ReactNode }) {
    return (
        <div className="space-y-2 p-2">
            <div className="text-gray-600 dark:text-gray-400">
                {children || <p>The page you are looking for does not exist.</p>}
            </div>
            <p className="flex flex-wrap items-center gap-2">
                <Button onClick={() => window.history.back()} variant="default" size="sm">
                    Go back
                </Button>
                <Link to="/">
                    <Button variant="secondary" size="sm">
                        Start Over
                    </Button>
                </Link>
            </p>
        </div>
    );
}
